<template>
  <div>
    <profile-app-bar
      title="Omat kuvat"
      prev-page="/profiili"
    />

    <div
      class="pa-4"
    >
      <v-card
        tile
        :style="{
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }"
      >
        <v-tabs
          v-model="selectedOrderByTab"
          centered
          grow
        >
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
            @click="() => go(tab.toParams)"
          >
            {{ tab.label }}
          </v-tab>
        </v-tabs>
      </v-card>

      <div
        class="mt-3"
      >
        <v-layout
          v-if="$wait.is('loading posts')"
          justify-center
          align-center
          fill-height
          class="pt-12"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-layout>

        <router-view
          :style="{
          display: $wait.is('loading posts') ? 'none' : 'block',
        }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileAppBar from '../components/ProfileAppBar.vue';

export default {
  components: {
    ProfileAppBar,
  },

  data: () => ({
    selectedOrderByTab: null,
  }),

  mounted() {
    this.selectedOrderByTab = this
      .tabs
      .findIndex(g => g.toParams.orderBy === this.$route.params.orderBy);
  },

  computed: {
    tabs() {
      return [
        {
          label: 'Uudet',
          toParams: {
            orderBy: 'uudet',
          },
        },
        {
          label: 'Puhutut',
          toParams: {
            orderBy: 'puhutut',
          },
        },
        {
          label: 'Tykätyt',
          toParams: {
            orderBy: 'tykatyt',
          },
        },
      ];
    },
  },

  methods: {
    go(params) {
      this.selectedOrderByTab = this.tabs.findIndex(t => t.toParams.orderBy === params.orderBy);

      this.$router.push({
        name: 'ownPosts',
        params,
      });
    },
  },
};
</script>
